import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  CircularProgress,
  Alert,
  Stack,
} from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';
import { useNotify, useTranslate, Title } from 'react-admin';
import { loginSettingsService } from '../services/loginSettingsService';

const LoginSettingsPage = () => {
  const translate = useTranslate();
  const notify = useNotify();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [mode, setMode] = useState('legacy');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await loginSettingsService.getSettings();
        if (!cancelled) {
          setMode(data?.webLoginMode === 'otp' ? 'otp' : 'legacy');
        }
      } catch (e) {
        if (!cancelled) {
          notify(translate('loginSettings.loadError'), { type: 'warning' });
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [notify, translate]);

  const onSave = async () => {
    setSaving(true);
    try {
      await loginSettingsService.updateSettings({ webLoginMode: mode });
      notify(translate('loginSettings.saved'), { type: 'info' });
    } catch (e) {
      notify(translate('loginSettings.saveError'), { type: 'warning' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ p: 3, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, maxWidth: 720 }}>
      <Title title={translate('loginSettings.title')} />
      <Typography variant="h5" sx={{ mb: 2 }}>
        {translate('loginSettings.title')}
      </Typography>

      <Alert severity="info" sx={{ mb: 2 }}>
        {translate('loginSettings.hint')}
      </Alert>

      <Card>
        <CardContent>
          <FormControl component="fieldset">
            <FormLabel component="legend">{translate('loginSettings.webMode')}</FormLabel>
            <RadioGroup value={mode} onChange={(e) => setMode(e.target.value)}>
              <FormControlLabel
                value="legacy"
                control={<Radio />}
                label={translate('loginSettings.legacy')}
              />
              <FormControlLabel
                value="otp"
                control={<Radio />}
                label={translate('loginSettings.otp')}
              />
            </RadioGroup>
          </FormControl>

          <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
            <Button
              variant="contained"
              startIcon={saving ? <CircularProgress size={18} /> : <SaveIcon />}
              onClick={onSave}
              disabled={saving}
            >
              {translate('ra.action.save')}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default LoginSettingsPage;
